import { InjectionToken } from '@angular/core';
import type { UiConfig } from './ui.interface';

export const UI_CONFIG = new InjectionToken<UiConfig>('UiConfig');

// Only inject for UI tests
export const TESTING_ANIMATION_DISABLED = new InjectionToken<boolean>(
  'Testing Close Animation Disabled',
);
